import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import Monitors from '../assets/monitors.svg';

const Wrapper = styled.div`
  text-align: left;
  width: calc(100% - 40px);
  padding: 0 20px;
  max-width: 1000px;
  margin-bottom: 60px;

  ${breakpoint('tablet')`
    display: flex;
  `};
`;

const Ul = styled.ul`
  padding-left: 23px;
  position: relative;

  &:before {
    content: '';
    position: absolute;
    left: 5px;
    width: 1px;
    height: calc(100% - 20px);
    top: 10px;
    background-color: #fdba29;
  }
`;

const Li = styled.li`
  margin-bottom: 30px;
  color: #686868;
  font-size: 14px;
  line-height: 16px;
  position: relative;

  &:last-of-type {
    margin-bottom: 0;
  }

  &:before {
    content: '';
    position: absolute;
    width: 5px;
    height: 5px;
    border: 1px solid #fdba29;
    background-color: #fff;
    border-radius: 100%;
    left: -21px;
    top: 50%;
    transform: translateY(-50%);
  }
`;

const Image = styled.img`
  display: none;

  ${breakpoint('tablet')`
    display: block;
    height: 205px;
    margin-left: auto;
  `};
`;

const Points = () => {
  return (
    <Wrapper>
      <Ul>
        <Li>
          <FormattedMessage
            id="shop.block.points.first"
            defaultMessage="Разработка баннеров для сайта"
          />
        </Li>
        <Li>
          <FormattedMessage
            id="shop.block.points.second"
            defaultMessage="Интеграция SMS сервиса"
          />
        </Li>
        <Li>
          <FormattedMessage
            id="shop.block.points.third"
            defaultMessage="Интеграция с кредитными компаниями"
          />
        </Li>
        <Li>
          <FormattedMessage
            id="shop.block.points.fourth"
            defaultMessage="Внедрение Google Analytics Ecommerce"
          />
        </Li>
        <Li>
          <FormattedMessage
            id="shop.block.points.fifth"
            defaultMessage="Перевод текстов"
          />
        </Li>
      </Ul>
      <Image src={Monitors} alt="" />
    </Wrapper>
  );
};

export default Points;
